<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Agenda General de Citas</h1>
      </div>
      <div style="display: flex">
        <div class="row">
          <div class="area">
            <div class="row padding-div-low">
              <full-calendar id="calendario_agendar_siccij" :events="eventosFullCalendar" :config="configuracionFullCalendar" ref="calendar" @event-selected="calendarioEventoClic"></full-calendar>
            </div>
            <div class="row new-row">
              <div class="col-3">
                <h5>Nomenclatura</h5>
              </div>
              <div class="col-3">
                <h5>Colores Psicólogos</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <ul>
                  <li>AGE: Agendada</li>
                  <li>CON: Concluida</li>
                  <li>CAN: Cancelada</li>
                </ul>
              </div>
              <div class="col-3">
                <div class="row" v-for="psicologo in psicologos">
                  <div class="col-1">
                    <i class="fas fa-circle" v-bind:style="{ color: psicologo.ColorDistintivo}" />
                  </div>
                  <div class="col-10">
                    {{psicologo.CuentaUsuario.Nombre}} {{psicologo.CuentaUsuario.ApellidoPaterno}} {{psicologo.CuentaUsuario.ApellidoMaterno}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade"
             id="modalConfirmacion"
             tabindex="-1"
             role="dialog"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true"
             v-if="citaDictamen!= null">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="tituloModalConfirmacion">No. de Folio de Cita: {{citaId}}</h5>
                <button type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">

                <br />
                <div class="row">
                  <div class="col-3">
                    <b>Evaluado: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.PersonaEvaluada.Nombre}} {{citaDictamen.PersonaEvaluada.ApellidoPaterno}} {{citaDictamen.PersonaEvaluada.ApellidoMaterno}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Fecha: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.FechaCitaString}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Juzgado: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.Dictamen.Expediente.AreaDBPJ.Nombre}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>No. Expediente: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.Dictamen.Expediente.Consecutivo}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Tema a Evaluar: </b>
                  </div>
                  <div class="col-9">
                    <span>{{citaDictamen.TemaEvaluacion.Nombre}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Sala Lúdica: </b>
                  </div>
                  <div class="col-9">
                    <span v-if="citaDictamen.SalaLudicaId">{{citaDictamen.SalaLudica.nombre}}</span>
                    <span v-else>No</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <b>Estatus: </b>
                  </div>
                  <div class="col-9">
                    <span v-if="citaDictamen.EstatusCitaId == 1">AGENDADA</span>
                    <span v-if="citaDictamen.EstatusCitaId == 2">CONCLUIDA</span>
                    <span v-if="citaDictamen.EstatusCitaId == 3">CANCELADA</span>
                  </div>
                </div>
                <div class="row new-row" v-if="citaDictamen != null && citaDictamen.EstatusCitaId == 1">
                  <div class="col-5">
                    <button class="form-control"> <i class="fas fa-info-circle"></i>Ver Detalle</button>
                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <button type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal">
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import FullCalendar from '@/../static/js/fullcalendar'
  export default {
    data() {
      return {
        nombreEvaluado: "",
        fechaCita: null,
        citaId: 0,
        citaDictamen: null,
        eventosFullCalendar: [],
        estatusFinalCita: -1,
        razonCancelacion: "",
        psicologos: [],
        configuracionFullCalendar: {
          slotLabelFormat: 'hh:mma',
          header: {
            left: 'prev,today,next',
            center: 'title',
            right: 'month,agendaWeek,agendaDay'
          },
          defaultView: 'agendaWeek',
          editable: false,
          businessHours: {
            daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
            start: '08:00:00', // a start time (10am in this example)  parametros.horarioAtencionInicio
            end: '16:00:00', // an end time (6pm in this example) parametros.horarioAtencionFinal
          },
          defaultDate: moment().add(1, 'days').format('YYYY-MM-DD'),
          selectConstraint: "businessHours",
          weekends: false,
          minTime: '08:00',
          maxTime: '16:00',
          allDaySlot: false,
          defaultTimedEventDuration: '00:15:00',
          slotDuration: '00:15:00',
          slotLabelInterval: "01:00",
          selectable: false,
          height: 1000,
          contentHeight: 'auto',
          displayEventTime: false

        }
      }
    },
    components: {
      FullCalendar
    },
    methods: {
      calendarioEventoClic: function (event, jsEvent, view) {
        //console.log(event)
        this.nombreEvaluado = event.title;
        this.citaId = event.id;
        this.fechaCita = event.description;
        this.citaDictamen = event.CitaDeDictamen;
        this.$forceUpdate();
        $('#modalConfirmacion').modal('toggle');
      },
      obtenerCitasAgenda: function () {
        var peticion = {
          "esPrueba": false,
          "MostrarTodo": true
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetCitasAgenda, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            this.eventosFullCalendar = response.data.AgendaEventosBloques;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarPsicologos: function () {
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.ObtenerPsicologos, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.psicologos = response.data.Psicologos
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      }

    }, computed: {

    }, mounted: function mounted() {
      this.obtenerCitasAgenda();
      this.buscarPsicologos();
    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  .alinear_izq {
    float: left;
  }

  .alinear_der {
    float: right;
  }

  .contenedor-puntero {
    background: #212529;
    border-radius: 2px;
    padding: 10px;
    border: 1px solid white;
    margin-bottom: 1.5em;
  }
</style>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  #calendario_agendar_siccij .fc-view-container {
    background-color: transparent !important;
    color: #343a40 !important;
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-view table {
    border-color: #212529 !important;
  }

  #calendario_agendar_siccij .fc-axis {
    background-color: #504f54;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
  }

  #calendario_agendar_siccij .fc-day-header {
    background-color: #212529 !important;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    padding: .75rem !important;
  }

  #calendario_agendar_siccij .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    text-shadow: none !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  #calendario_agendar_siccij .fc-state-active {
    background-color: rgb(174, 174, 174) !important;
  }

  #calendario_agendar_siccij .fc-button:focus {
    outline: none !important;
  }

  #calendario_agendar_siccij .fc-today {
    background-color: rgba(242,242,242,0.5) !important;
    color: white !important;
  }

  #calendario_agendar_siccij .fc-day-number {
    color: white !important;
  }

  #calendario_agendar_siccij .fc-event {
    background-color: #212529;
    border-color: #32383e !important;
    color: white !important;
    padding: 0 .375rem !important;
    font-size: 1.0em;
    border-radius: .25rem !important;
    /*width: 80% !important;*/
    text-align: left !important;
    margin: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/CalendarioGeneralDeCitas/CalendarioGeneralDeCitas.vue